// filepath: /Users/mk/work/2024/jimon-generator-web/src/App.tsx
import React from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from 'react-router-dom';
import JimonGenerator from './components/JimonGenerator';
import AdminPanel from './components/AdminPanel';
import Header from './components/Header';
import { AdminRoute } from './utils/auth';
import AuthForm from './components/AuthForm';

// LoginPage コンポーネント
const LoginPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-100">
      <Header />
      <div className="container mx-auto px-4 py-8">
        <AuthForm />
      </div>
    </div>
  );
};

// App コンポーネント
function App() {
  return (
    <Router>
      <Routes>
        {/* メインアプリケーションルート */}
        <Route path="/" element={<JimonGenerator />} />

        {/* ログインページ */}
        <Route path="/login" element={<LoginPage />} />

        {/* 管理者専用ページ */}
        {/* <Route
          path="/admin"
          element={
            <AdminRoute>
              <div className="min-h-screen bg-gray-100">
                <Header />
                <AdminPanel />
              </div>
            </AdminRoute>
          }
        /> */}

        {/* 404ページ - ホームページにリダイレクト */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
